import i18next from 'i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { SUPPORTED_LOCALES, DEFAULT_LOCALE, LOCALE_STORAGE_KEY } from './locales';

// Two namespaces auto-loaded at startup; feature namespaces are lazy-loaded per route.
export const DEFAULT_NS = 'common';
export const AUTO_NAMESPACES = ['common', 'common-data'] as const;

const i18n = i18next
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next);

// `init` is called once; the returned promise is used in LocaleProvider to avoid
// rendering the app before at least the 'common' namespace is ready.
export const i18nReadyPromise = i18n.init({
  ns: [...AUTO_NAMESPACES],
  defaultNS: DEFAULT_NS,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: SUPPORTED_LOCALES,
  load: 'currentOnly', // don't try 'zh' when user picks 'zh-CN'
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },
  detection: {
    order: ['localStorage', 'navigator', 'htmlTag'],
    lookupLocalStorage: LOCALE_STORAGE_KEY,
    caches: ['localStorage'],
    convertDetectedLanguage: (lng: string) => {
      // Map browser locales to supported ones
      if (lng.startsWith('zh')) return lng.includes('TW') || lng.includes('HK') ? 'zh-TW' : 'zh-CN';
      if (lng.startsWith('ru')) return 'ru';
      return 'en';
    },
  },
  interpolation: {
    escapeValue: false, // React already escapes
  },
  react: {
    useSuspense: false, // use loading state instead of Suspense
  },
});

export default i18n;
